import SearchNotificationImage from '@assets/svg/search-notification-light.svg';
import Rolling from '@assets/gif/rolling.gif';
import CloseImage from '@assets/svg/close.svg';
import { ClickAwayListener } from '@material-ui/core';
import {
  Close,
  LoadingImg,
  Search,
  SearchButton,
  SearchContainer,
  SearchImg,
  StyledOption,
  Container,
  StyledOptionBlue,
  StyledOptionBlack,
  RowDiv,
  StyledOptionCancel,
} from './SearchBarExpansiveTwo.styles';

interface NameAndId {
  name: string;
  id: string;
}
interface SearchBarProps {
  showOptions: NameAndId[];
  searchText: string;
  placeholder: string;
  loadingSearch: boolean;
  isDisabled?: boolean;
  alreadySearch: boolean;
  showErasedSearch: boolean;
  searchOnKeyDown: (event: any) => void;
  searchIconOnClick: () => void;
  closeIconOnClick: () => void;
  onClickFilter: (input: NameAndId) => void;
  searchOnChange: any;
  setShowOptions: any;
  labelMissingSearch: string;
  whenMissingClicked: () => void;
}
const SearchBarExpansiveManufacturer = ({
  searchText,
  isDisabled,
  placeholder,
  searchOnChange,
  searchOnKeyDown,
  loadingSearch,
  showErasedSearch,
  searchIconOnClick,
  closeIconOnClick,
  alreadySearch,
  showOptions,
  onClickFilter,
  setShowOptions,
  labelMissingSearch,
  whenMissingClicked,
}: SearchBarProps) => {
  const handleClickAway = () => {
    setShowOptions([]);
  };
  return (
    <>
      <SearchContainer>
        {!isDisabled && (
          <SearchImg src={SearchNotificationImage} alt="search" />
        )}
        <Search
          value={searchText}
          disabled={isDisabled}
          placeholder={placeholder}
          autoComplete="off"
          onChange={e => {
            if (!isDisabled) searchOnChange(e.target.value);
          }}
          onKeyDown={searchOnKeyDown}
          haveResults={
            showOptions.length > 0 ||
            (showOptions.length === 0 && showErasedSearch && !isDisabled)
          }
        />
        {loadingSearch && <LoadingImg src={Rolling} alt="loading" />}
        {showErasedSearch && searchText.length > 0 && !isDisabled && (
          <Close src={CloseImage} alt="close" onClick={closeIconOnClick} />
        )}
        {!loadingSearch &&
          !showErasedSearch &&
          (searchText.length > 0 || alreadySearch) && (
            <SearchButton onClick={searchIconOnClick}>Search</SearchButton>
          )}
      </SearchContainer>
      <ClickAwayListener onClickAway={handleClickAway}>
        <Container
          haveResults={
            showOptions.length > 0 ||
            (showOptions.length === 0 && showErasedSearch && !isDisabled)
          }
        >
          {showOptions.map(item => (
            <StyledOption
              onClick={() => {
                onClickFilter(item);
              }}
            >
              {item.name}
            </StyledOption>
          ))}
          {showOptions.length === 0 && showErasedSearch && !isDisabled && (
            <>
              <StyledOptionBlack onClick={() => {}}>
                No Manufacturer found
              </StyledOptionBlack>
              <RowDiv>
                <StyledOptionCancel onClick={closeIconOnClick}>
                  Cancel
                </StyledOptionCancel>
                <StyledOptionBlue onClick={whenMissingClicked}>
                  {labelMissingSearch}
                </StyledOptionBlue>
              </RowDiv>
            </>
          )}
        </Container>
      </ClickAwayListener>
    </>
  );
};

export { SearchBarExpansiveManufacturer };
